module.exports = __webpack_public_path__ + "img/W3D_humanbody.d796fae7.png";